'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _values = require('lodash/values');var _values2 = _interopRequireDefault(_values);
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);


var _components = require('../../../components');


var _constants = require('../../../constants');
var _MapboxService = require('../../../services/MapboxService/MapboxService');var _MapboxService2 = _interopRequireDefault(_MapboxService);
var _helpers = require('../../../services/MapboxService/helpers');



var _constants2 = require('../../../services/MapboxService/constants');





var _CompanyMap = require('./CompanyMap.scss');var styles = _interopRequireWildcard(_CompanyMap);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Helpers
// styles
var DynamicCompanyMap = function (_Component) {_inherits(DynamicCompanyMap, _Component);function DynamicCompanyMap() {var _temp, _this, _ret;_classCallCheck(this, DynamicCompanyMap);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.




























    getMapRef = function (ref) {_this.mapContainer = ref;}, _this.

    propertyCellClickHandler = function (preloadData) {
      var pid = preloadData.propertyId;
      _this.props.openDetails({}, pid);
    }, _this.

    toggleFavorite = function () {
      // TODO add favorites logic
    }, _this.

    handleMapLoad = function () {
      _this.fitPropertiesToMapBounds();
      _this.renderMapPins();
      _this.map.on('click', _this.handleMapClick);
      _this.map.on('mousemove', _this.handleMapMouseMove);
    }, _this.

    handleMapClick = function (evt) {
      if (!_this.map) {return;}

      var features = _this.map.queryRenderedFeatures(evt.point, {
        layers: [_constants2.PINS_LAYOUT_ID] });


      if (!features.length) {return;}

      var feature = features[0];

      var ids = JSON.parse((0, _get2.default)(feature, 'properties.ids', '[]'));
      var coordinates = (0, _get2.default)(feature, 'geometry.coordinates', []);
      var zIndex = (0, _get2.default)(feature, 'properties.zIndex');
      _this.openInfoWindow(ids, coordinates, zIndex);
    }, _this.

    handleMapMouseMove = function (evt) {
      if (!_this.map) {return;}

      var features = _this.map.queryRenderedFeatures(evt.point, {
        layers: [_constants2.PINS_LAYOUT_ID] });


      _this.map.getCanvas().style.cursor = features.length ? 'pointer' : '';
    }, _this.

    handleLocaleChange = function () {
      _this.reInitMapIcons();
      _this.renderMapPins();
    }, _this.

    reInitMapIcons = function () {
      var icons = _constants2.requiredMapIcons[_constants2.MAP_TYPES.COMPANY];
      icons.forEach(function (icon) {return _MapboxService2.default.initIconToMap(_this.map, icon);});
    }, _this.

    initDynamicMap = function () {var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.locale;
      _this.map = null;
      _this.initializeDynamicMap(locale);
    }, _this.

    initializeDynamicMap = function () {
      _this.map = _MapboxService2.default.createMapInstance(
      _this.mapContainer, Object.assign({},
      _MapboxService2.default.getMapOptions('company')),
      _this.props.locale,
      _constants2.requiredMapIcons[_constants2.MAP_TYPES.COMPANY]);


      _this.map.once('load', _this.handleMapLoad);
      _this.map.touchZoomRotate.disableRotation();

      if (_this.props.isMobile) {
        (0, _helpers.addMultitouchGestures)(_this.map);
      }
    }, _this.

    openInfoWindow = function (ids, coordinates, zIndex) {
      if (!ids || !ids.length) {return;}
      var properties = ids.map(function (id) {return (0, _get2.default)(_this.props, ['propertiesIdsMap', id], {});});
      var content = _this.createPinContent(properties);

      _this.props.setPinAsReviewed(ids[0]);
      _this.currentPinData = {
        id: ids[0],
        zIndex: zIndex };


      _this.renderMapPins();

      _this.popup = _MapboxService2.default.createInfoWindow(content).
      setLngLat(coordinates).
      addTo(_this.map);

      _MapboxService2.default.locateInfoWindow(_this.map, coordinates, _this.popup);
    }, _this.

    fitPropertiesToMapBounds = function () {var groupedProperties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.groupedProperties;
      var bounds = _MapboxService2.default.createBounds();
      var coordinates = Object.keys(groupedProperties).map(function (key) {return key.split('|').reverse();});

      coordinates.forEach(function (item) {return bounds.extend(item);});

      if (coordinates.length) {
        _this.map.fitBounds(bounds, { padding: 70 });
      }
    }, _this.

    switchToDynamicMap = function () {
      _this.setState({ isDynamicMap: true });
      _this.initDynamicMap();
    }, _this.

    clearPins = function () {
      if (!_this.map || !_this.map.getSource(_constants2.PINS_SOURCE_ID)) return null;

      return _this.map.removeSource(_constants2.PINS_SOURCE_ID);
    }, _this.

    clearMap = function () {
      if (!_this.map) {return;}
      _this.map.off('click', _this.handleMapClick);
      _this.map.off('mousemove', _this.handleMapMouseMove);
      if (_this.props.isMobile) {
        (0, _helpers.removeMultitouchGestures)(_this.map);
      }
      _this.map.remove();
    }, _this.

    createPinContent = function (properties) {var
      locale = _this.props.locale;
      var multiple = properties.length > 1;
      var lang = properties[0].address[locale] ? locale : _constants.language.fallback;
      var address = properties[0].address[lang];
      var shouldHideHouseNumber = properties.some(function (item) {return !(0, _get2.default)(item, 'address[' + lang + '].house_number');});
      var houseNumber = shouldHideHouseNumber ? ', ' : ' ' + address.house_number + ', ';

      var addressString = multiple ?
      _react2.default.createElement('div', { className: styles.addressMultiPin }, '' +
        address.street_name + houseNumber + address.city_name) :

      null;

      return (
        _react2.default.createElement('div', {
            className: multiple ? styles.multipleCellWrap : '' },

          addressString,
          _react2.default.createElement(_components.OMPropertiesList, {
            properties: properties,
            isMobile: _this.props.isMobile,
            locale: locale,
            translate: _this.props.translate,
            className: multiple ? 'multiPinList' : '',
            openDetailsPopup: _this.propertyCellClickHandler,
            toggleFavorite: _this.toggleFavorite,
            needScroll: multiple,
            mapPropertyCell: true,
            isRtl: _this.props.isRtl })));



    }, _this.

    formatPropertyPins = function (propertiesArray) {
      var isReviewed = false;
      var type = 'property';

      if ((0, _get2.default)(propertiesArray, '[0].address.location')) {
        var ids = propertiesArray.map(function (item) {return item.id;});var _propertiesArray$0$ad =
        propertiesArray[0].address.location,lat = _propertiesArray$0$ad.lat,lon = _propertiesArray$0$ad.lon;

        isReviewed = ids.some(function (id) {return _this.props.reviewedPins.includes(id);});
        var shouldMoveOnTop = _this.currentPinData && ids.includes(_this.currentPinData.id);
        var zIndex = _this.currentPinData && (shouldMoveOnTop ?
        _this.currentPinData.zIndex + 1 :
        _this.currentPinData.zIndex);

        return [lat, lon, {
          ids: ids,
          type: type,
          reviewed: isReviewed,
          number: ids.length,
          propertiesArray: propertiesArray,
          zIndex: zIndex || 1 }];

      }

      return [];
    }, _this.

    createPropertyPin = function (propertiesArray) {
      var propertyPin = void 0;
      var isReviewed = false;
      var type = 'property';

      if ((0, _get2.default)(propertiesArray, '[0].address.location')) {
        var ids = propertiesArray.map(function (item) {return item.id;});var _propertiesArray$0$ad2 =
        propertiesArray[0].address.location,lat = _propertiesArray$0$ad2.lat,lon = _propertiesArray$0$ad2.lon;

        isReviewed = ids.some(function (id) {return _this.props.reviewedPins.includes(id);});

        propertyPin = _MapboxService2.default.createPin(lat, lon, {
          ids: ids,
          type: type,
          reviewed: isReviewed,
          number: ids.length,
          propertiesArray: propertiesArray });


        var pinContent = _this.createPinContent(propertiesArray);
        var infoWindow = _MapboxService2.default.createInfoWindow(pinContent);

        propertyPin.setPopup(infoWindow);

        var handleInfoWindowOpen = function handleInfoWindowOpen() {return _MapboxService2.default.setReviewedIcon(propertyPin);};
        infoWindow.on('open', handleInfoWindowOpen);
      }
      return propertyPin;
    }, _this.

    findReviewedPinsThatShouldBeRepainted = function (reviewedPins) {return (_this.pins || []).filter(
      function (pin) {return pin.ids.some(function (id) {return reviewedPins.includes(id);});});}, _this.


    renderMapPins = function () {var groupedPins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.groupedProperties;
      if (!_this.map) return null;

      var pinsData = (0, _values2.default)(groupedPins).map(_this.formatPropertyPins);
      var currentSource = _this.map.getSource(_constants2.PINS_SOURCE_ID);

      if (currentSource) {
        var geoJsonPinsData = _MapboxService2.default.createGeoJsonPinsData(pinsData);
        currentSource.setData(geoJsonPinsData);
      } else {
        var geoJsonPins = _MapboxService2.default.createGeoJsonPins(pinsData);
        _MapboxService2.default.applyPinsGeoJson(_this.map, geoJsonPins);
      }

      return _this.map;
    }, _temp), _possibleConstructorReturn(_this, _ret);}DynamicCompanyMap.prototype.componentDidMount = function componentDidMount() {this.initDynamicMap();};DynamicCompanyMap.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {var localeIsChanged = newProps.locale && newProps.locale !== this.props.locale;var pinsTypeIsChanged = newProps.pinsType && newProps.pinsType !== this.props.pinsType;if (localeIsChanged) {_MapboxService2.default.changeMapLocale(this.map, newProps.locale, this.handleLocaleChange);}if (pinsTypeIsChanged) {this.popup && this.popup.remove();this.popup = null;this.fitPropertiesToMapBounds(newProps.groupedProperties);this.renderMapPins(newProps.groupedProperties);}if (!(0, _isEqual2.default)(newProps.reviewedPins, this.props.reviewedPins)) {this.findReviewedPinsThatShouldBeRepainted(newProps.reviewedPins).forEach(_MapboxService2.default.setReviewedIcon);}};DynamicCompanyMap.prototype.componentWillUnmount = function componentWillUnmount() {this.clearMap();_MapboxService2.default.cleanup();};DynamicCompanyMap.prototype.

  render = function render() {
    return (
      _react2.default.createElement('div', {
        className: styles.dynamicMap,
        ref: this.getMapRef }));


  };return DynamicCompanyMap;}(_react.Component);


DynamicCompanyMap.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  pinsType: _propTypes2.default.string,
  groupedProperties: _propTypes2.default.object,
  propertiesIdsMap: _propTypes2.default.object,
  reviewedPins: _propTypes2.default.array,
  setPinAsReviewed: _propTypes2.default.func,
  openDetails: _propTypes2.default.func };exports.default =


DynamicCompanyMap;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/CompanyMap/DynamicCompanyMap.js
// module id = 2629
// module chunks = 0